<template>
    <div>
        <div v-if="data.length > 0" class="text-grey-darkest">
            <div class="bg-white shadow-md rounded mb-6 mt-2">
                <table class="text-left w-full border-collapse">
                    <thead>
                    <tr>
                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                            Modules
                        </th>
                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                            on/off
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="hover:bg-grey-lighter cursor-pointer" v-for="(item, idx) in tempModule">
                        <td class="pl-4 py-2 border-b border-grey-light text-xs">
                            {{ item.title }}
                        </td>
                        <td class="pl-4 py-2 border-b border-grey-light">
                            <b-row>
                                <b-col>
                                    <b-form-checkbox switch size="lg" :id="`switch-total${idx}`" v-model="item.enable" @change="update(item)"/>
                                </b-col>
                            </b-row>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-else class="mt-10 text-center">
            <div class="flex-col">
                <div>
                    <img width="400" src="/images/blank.svg">
                </div>
                <div class="mt-4">
                    <div class="text-lg text-grey-darkest mb-2 flex justify-center">
                        <div class="text-xl w-1/4 tracking-wide">You haven't created a code yet!</div>
                    </div>
                    <button @click="addCode" class="bg-followup-nav px-4 py-2 rounded-full text-white focus:outline-none hover:bg-followup-nav-darker text-xl">Click here to add your first code!</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Form  from "../../../utils/form";
import axios from "axios";
import Swal  from "sweetalert2";

export default {
    name: 'module',
    props: ['data', 'team'],

    data() {
        return {
            form: new Form({
                code: '',
                title: '',
                enable: '',
            }),
            tempModule: {},
        }
    },

    mounted() {
        this.tempModule = this.data;
    },

    methods: {
        update(item) {
            let self = this;
            axios.put(route('api.settings.codes.module.update', {code:item.id}), {enable:!item.enable})
                .then(function () {
                    self.fireSuccessToast('Module Updated!');
                });
        },

        fireSuccessToast(message) {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });

            Toast.fire({
                type: 'success',
                title: message,
            });
        },
    }
}
</script>
